import { render } from "./uploadResume.vue?vue&type=template&id=52b7d6ca"
import script from "./uploadResume.vue?vue&type=script&lang=js"
export * from "./uploadResume.vue?vue&type=script&lang=js"

import "./uploadResume.vue?vue&type=style&index=0&id=52b7d6ca&lang=less"

import exportComponent from "/root/.jenkins/workspace/embeddedJobWebProd/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__